export default theme => ({
	container: {
		position: "absolute",
		bottom: 0,
		right: 20,
		height: 50,
		width: 250,
		backgroundColor: "transparent"
	},
	label: {
		color: "#FFFFFF",
		fontFamily: "Questrial,Arial,sans,sans-serif",
		fontSize: 12,
		textShadow: "0px 0px 4px #000"
	},
	root: {
		height: 16,
		width: 250,
		margin: "4px 0 0 0",
		borderRadius: 8,
		color: "#FFBD54"
	},
	colorPrimary: {
		backgroundColor: "#FFBD54",
		border: "0.5px solid #4D4D4D"
	},
	colorSecondary: {
		backgroundColor: "#FFFFFF"
	},
	barColorPrimary: {
		backgroundColor: "#FFBD54"
	},
	barColorSecondary: {
		backgroundColor: "#FFFFFF"
	},
	determinate: {
		backgroundColor: "#fff"
	},
	progress: {
		position: "absolute",
		bottom: 0,
		right: "50%",
		fontSize: 10,
		padding: 0,
		lineHeight: "10px",
		fontWeight: 900
	}
});
